import ArticleView from './ArticleView'
export default ArticleView
